import { render, staticRenderFns } from "./AssetList.vue?vue&type=template&id=dd3730f4&scoped=true&"
import script from "./AssetList.vue?vue&type=script&lang=js&"
export * from "./AssetList.vue?vue&type=script&lang=js&"
import style0 from "./AssetList.vue?vue&type=style&index=0&id=dd3730f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd3730f4",
  null
  
)

export default component.exports